module.exports = __webpack_public_path__ + "static/media/assemblyHandle.8babc8c2.png";